module.exports = __webpack_public_path__ + "img/Image5.af4c3f6a.png";